import { tzAxios } from 'api/axios';
import { ConcertsResponse } from 'api/responseTypes';

export const getUpcomingConcerts = async () =>
  (await tzAxios.get<ConcertsResponse>('/ticket-zone/home?type=CONCERT')).data;
